import React from 'react';
import { Modal } from '@superops/ui-design-system';
import { SVGIcon } from '@superops/super-icons';
import { FormattedMessage } from 'react-intl';

function ChangeConfirmationModal({
  activeModal,
  toggleModalActive,
  handleChange,
  confirmationModalContent,
  confirmationModalTitle
}) {
  return (
    <Modal
      open={activeModal}
      onClose={() => toggleModalActive()}
      variant="confirmation"
      title={
        <FormattedMessage
          id={confirmationModalTitle || 'common.confirmation'}
        />
      }
      iconSize="xl"
      primaryAction={{
        content: (
          <div className="flex actr ">
            <SVGIcon name="CircleTickOutlineMinor" />
            <div className="ml8">
              <FormattedMessage id="common.yes" />
            </div>
          </div>
        ),
        onAction: () => {
          handleChange();
        }
      }}
      secondaryActions={[
        {
          content: <FormattedMessage id="common.cancel" />,
          onAction: () => toggleModalActive()
        }
      ]}
    >
      <div className="mt-10">
        <FormattedMessage id={confirmationModalContent} />
      </div>
    </Modal>
  );
}

export default ChangeConfirmationModal;
